// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a9fedb6f","732":"a1f4b158","977":"59f397fa"}[chunkId] + ".chunk.js";
};